import React, { useState } from "react";
import { Sparkle } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { APP_VERSION, CHANGELOG } from "@/changelog";

export function WhatsNew() {
  const { t } = useApp();
  const seen = typeof window !== "undefined" ? localStorage.getItem("sb_seen_version") : APP_VERSION;
  const onboarded = typeof window !== "undefined" ? localStorage.getItem("sb_onboarded") : "1";
  const [open, setOpen] = useState(seen !== APP_VERSION && !!onboarded);
  const latest = CHANGELOG[0];
  const close = () => { localStorage.setItem("sb_seen_version", APP_VERSION); setOpen(false); };
  if (!latest) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent data-testid="whatsnew-modal">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <Sparkle size={22} weight="fill" style={{ color: "var(--app-strong)" }} />{t("whatsNewTitle")} · v{latest.version}
          </DialogTitle>
          <DialogDescription>{latest.date}</DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 list-disc pl-5 font-body text-sm text-gray-800">
          {latest.changes.map((c, i) => (<li key={i} data-testid={`whatsnew-item-${i}`}>{c}</li>))}
        </ul>
        <button data-testid="whatsnew-close" onClick={close} className="sb-btn w-full py-3 mt-2 text-white font-medium" style={{ background: "var(--app-primary)" }}>{t("whatsNewClose")}</button>
      </DialogContent>
    </Dialog>
  );
}
